import React, { useEffect, useState } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { PiSealWarningFill } from "react-icons/pi";
import { errorMessage } from "../../../utils/errorMessage";
import toast from "react-hot-toast";
import { useQuery } from "@tanstack/react-query";
import { API } from "../../../constants/api";
import useAuthAxios from "../../../utils/baseAxios";
import { useUser } from "../../../context/user-context";
import { coins } from "../../../constants/constants";
import { formatAmount } from "../../../utils/formatTime";
import Select from "react-select";
// import GetRates from "../../../components/utils/GetRates";
import useRates from "../../../hooks/useRates";
import useUserAsset from "../../../hooks/useUserAssets";

const Tranfer = ({
  setOpenTransfer,
  setOpenTransferPreview,
  transferAmount,
  setTransferAmount,
  setTransferBankName,
  transferBankNumber,
  setTransferBankNumber,
  transferBankCode,
  setTransferBankCode,
  transferUserBankName,
  setTransferUserBankName,
  transferSelectedCoinObj,
  setTransferSelectedCoinObj,
}: any) => {
  const { userDetails, theme } = useUser();
  const [transferDisabled, setTransferDisabled] = useState<boolean>(false);
  const walletBalances = userDetails?.user.deexWalletBalances;
  const [coinBalancee, setCoinBalancee] = useState<number | null>(null);
  const { rate: coinRate } = useRates(
    transferSelectedCoinObj?.abbr?.toLowerCase()
  );
  const [coinBalanceeInUsdt, setCoinBalanceeInUsdt] = useState<number | null>(
    null
  );
  const { walletBalanceInUsdt } = useUserAsset();

  const isNumber = (str: any) => {
    if (str.trim() === "") {
      return false;
    }

    return !isNaN(str);
  };
  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (isNumber(value)) {
      setTransferAmount(value);
    } else {
      setTransferAmount("");
    }
  };
  const axiosInstance = useAuthAxios();

  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error1 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });
  // console.log(allBanks);
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1]);
  const getbankName = async () => {
    const response = await axiosInstance.get(
      API.verifyAccountNumber(transferBankNumber, transferBankCode)
    );
    return response.data;
  };
  const {
    data: userName,
    error: error2,
    isLoading: isLoadingUserName,
  } = useQuery({
    queryKey: ["get-user-name", transferBankNumber, transferBankCode],
    queryFn: getbankName,
    retry: 1,
    enabled: transferBankNumber.length === 10 && !!transferBankCode,
  });
  // console.log(userName);
  useEffect(() => {
    if (
      userName?.data.accountName &&
      transferBankNumber.length === 10 &&
      transferBankCode
    ) {
      setTransferUserBankName(userName?.data.accountName);
    }
  }, [transferBankCode, transferBankNumber.length, userName?.data.accountName]);
  useEffect(() => {
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error2]);

  const handleCoinChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAbbr = e.target.value;
    const selectedAbbrLC = e.target.value.toLowerCase();
    const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);

    setTransferSelectedCoinObj(coin);
    const coinBalances = walletBalances[selectedAbbrLC];
    const coinBalancesInUsdt = walletBalanceInUsdt[selectedAbbrLC];
    if (coinBalances !== undefined) {
      setCoinBalancee(coinBalances);
      setCoinBalanceeInUsdt(coinBalancesInUsdt);
      // Here, you can display the balance in the UI, like updating state
    } else {
    }
  };

  const customSelectStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: "transparent",
      borderColor: state.isFocused
        ? "#0B75C2"
        : theme === "dark"
        ? "#4B5563"
        : "#d1d5db",
      boxShadow: state.isFocused ? "0 0 0 1.5px #0B75C2" : "none",
      minHeight: "48px",
      borderRadius: "0.75rem",
      fontSize: "15px",
      color: theme === "dark" ? "#D1D5DB" : "#374151",
      outline: "none",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? theme === "dark"
          ? "#192025"
          : "#E8F3FC"
        : state.isFocused
        ? theme === "dark"
          ? "#232B36"
          : "#F3F4F6"
        : theme === "dark"
        ? "#1F2B36"
        : "#fff",
      color: theme === "dark" ? "#D1D5DB" : "#1F2937",
      fontSize: "15px",
      padding: "10px 16px",
      cursor: "pointer",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: theme === "dark" ? "#D1D5DB" : "#374151",
      fontWeight: 500,
    }),
    menu: (provided: any) => ({
      ...provided,
      borderRadius: "0.75rem",
      boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
      zIndex: 20,
      backgroundColor: theme === "dark" ? "#1F2B36" : "#fff",
    }),
    input: (provided: any) => ({
      ...provided,
      color: theme === "dark" ? "#D1D5DB" : "#374151",
      fontSize: "15px",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: theme === "dark" ? "#6B7280" : "#6B7280",
      fontSize: "15px",
    }),
  };

  const getTransferLimit = async () => {
    const response = await axiosInstance.get(API.getTansferLimit);
    return response.data;
  };

  const { data: transferLimit, error: error3 } = useQuery({
    queryKey: ["transfer-limit"],
    queryFn: getTransferLimit,
    retry: 1,
  });

  useEffect(() => {
    if (error3) {
      const newError = error3 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error3]);

  const transferLimitValue = transferLimit?.data?.limit?.remainingLimit;
  const transferLimitPercentage = (transferLimitValue / 50000) * 100;
  const coinBalanceeInNaira = coinBalanceeInUsdt
    ? coinBalanceeInUsdt * coinRate
    : 0;
  useEffect(() => {
    if (
      !transferSelectedCoinObj?.abbr ||
      !transferBankNumber ||
      !transferAmount ||
      coinBalancee == null ||
      coinBalancee <= 0 ||
      Number(transferAmount) > transferLimitValue ||
      Number(transferAmount) > coinBalanceeInNaira
    ) {
      setTransferDisabled(true);
    } else {
      setTransferDisabled(false);
    }
  }, [
    transferAmount,
    transferBankNumber,
    transferSelectedCoinObj?.abbr,
    coinBalancee,
    transferLimitValue,
    coinBalanceeInNaira,
  ]);

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenTransfer(false);
            }}
            className="flex items-center gap-2 "
          >
            <BsArrowLeft className=" text-gray-800 dark:text-gray-200 text-[16px]" />
          </button>
          <h4 className="text-gray-900  dark:text-gray-100 font-sora font-semibold text-[20px]">
            Send Money
          </h4>
        </div>

        <div className="w-full mt-6">
          <div className="flex items-center flex-col bg-[#E8F3FC] rounded-[8px] px-4 py-2 mb-4">
            <div className="flex w-full items-center justify-start gap-1">
              <PiSealWarningFill className="text-[20px] text-[#0B75C2] " />
              <span className="text-[#4B5563] text-[12px] font-medium">
                You can only send ₦{" "}
                <strong>{formatAmount(transferLimitValue)}</strong>{" "}
                {transferLimitValue === 50000
                  ? "daily"
                  : transferLimitValue < 50000
                  ? "today"
                  : ""}
              </span>
            </div>
            <div className="w-full flex items-center mt-1">
              <div className="flex-1 h-[6px] rounded-full bg-[#13181B] overflow-hidden">
                <div
                  className="h-[6px] bg-[#0494FC]"
                  style={{ width: `${100 - transferLimitPercentage}%` }}
                />
              </div>
              <span className="ml-3 text-[#1A1A1A] text-[12px] ">
                {100 - transferLimitPercentage}%
              </span>
            </div>
          </div>
          <div className="w-full mt-6">
            <label className="text-gray-700  dark:text-gray-300">
              Account number
            </label>
            <input
              type="number"
              value={transferBankNumber}
              onChange={(e) => setTransferBankNumber(e.target.value)}
              placeholder="10-digit account number"
              className="w-full  dark:text-gray-300 text-gray-700 spin-button-none border-gray-300 dark:border-gray-600 bg-transparent  h-[48px] mt-2 mb-6 lgss:mt-4 outline-none text-[15px] border   px-4 spin-button-none rounded-xl "
            />
            <label className="text-gray-700   dark:text-gray-300">
              Choose bank
            </label>
            <div className="w-full mt-2 lgss:mt-4">
              <Select
                options={
                  allBanks?.data.map((bank: any) => ({
                    value: bank.bankCode,
                    label: bank.bankName,
                  })) || []
                }
                onChange={(selected: any) => {
                  setTransferBankCode(selected.value);
                  setTransferBankName(selected.label);
                }}
                placeholder="Select bank"
                isSearchable
                classNamePrefix="react-select"
                styles={customSelectStyles}
              />
            </div>
            {isLoadingUserName ? (
              <div className="mt-6">
                <div className="w-full dark:bg-[#1F2B36] border-gray-300 flex justify-start items-center dark:border-gray-600  text-gray-700 dark:text-gray-300 h-[48px] mt-2 outline-none text-[15px] border  bg-[#F7F8F9] pr-2 pl-2  rounded-xl">
                  <h4 className="text-[15px] text-gray-700 dark:text-gray-300  font-medium">
                    Loading...
                  </h4>
                </div>
              </div>
            ) : transferBankNumber.length === 10 && transferBankCode ? (
              <div className="mt-6">
                <label className="text-gray-700  dark:text-gray-300">
                  Account name
                </label>
                <div className="w-full dark:bg-[#1F2B36] border-gray-300 flex justify-start items-center dark:border-gray-600  text-gray-700 dark:text-gray-300 h-[48px] mt-2 outline-none text-[15px] border  bg-[#F7F8F9] pr-2 pl-2  rounded-xl">
                  <h4
                    className={`text-[15px]  font-medium ${
                      !transferUserBankName
                        ? "text-gray-300 dark:text-gray-500 "
                        : "text-gray-700 dark:text-gray-300 "
                    }`}
                  >
                    {transferUserBankName
                      ? transferUserBankName
                      : "Account name"}
                  </h4>
                </div>
              </div>
            ) : null}
            <div className="mt-6">
              <label className="text-gray-700  dark:text-gray-300">
                Select Wallet
              </label>
              <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2 w-full flex gap-1 justify-start items-center">
                {transferSelectedCoinObj?.abbr && (
                  <div className="flex justify-center items-center  w-[20px] h-[20px] rounded-full">
                    <img
                      src={transferSelectedCoinObj?.logo}
                      className="w-full h-full bg-cover"
                      alt=""
                    />
                  </div>
                )}

                <select
                  value={transferSelectedCoinObj?.abbr || ""}
                  onChange={handleCoinChange}
                  className="outline-none w-full text-[14px] text-gray-800 bg-transparent dark:text-gray-400"
                >
                  <option value="" className="" disabled>
                    Select a coin
                  </option>
                  {coins.map((coin: any, index: any) => (
                    <option key={index} value={coin.abbr}>
                      {coin.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex mt-2 justify-between font-semibold items-center">
                <h4 className="text-[12px] text-gray-500 dark:text-gray-400">
                  Balance: {formatAmount(coinBalancee)}{" "}
                  {transferSelectedCoinObj?.abbr ?? ""}
                </h4>
              </div>
            </div>
            <div className="w-full mt-6">
              <div className="flex justify-between gap-4 items-center">
                <div className="w-full ">
                  <h4 className="text-[14px] text-gray-800 dark:text-gray-300">
                    Amount
                  </h4>
                  <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2  flex gap-1 justify-between items-center">
                    <input
                      type="number"
                      placeholder="Amount"
                      value={transferAmount}
                      onChange={handleAmountChange}
                      className="text-gray-600 w-10/12 dark:text-gray-300 bg-transparent spin-button-none  text-[13px] text-left outline-none"
                    />
                    <h4 className="text-[13px] text-secondary_button font-semibold">
                      NGN
                    </h4>
                  </div>
                  {transferAmount &&
                    Number(transferAmount) &&
                    coinBalancee !== null &&
                    Number(transferAmount) > coinBalanceeInNaira && (
                      <p className="text-red-500 text-[12px] mt-1">
                        Amount exceeds available balance
                      </p>
                    )}

                  {Number(transferAmount) > transferLimitValue && (
                    <p className="text-red-500 text-[12px] mt-1">
                      Amount exceeds daily transfer limit
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <button
            onClick={() => {
              setOpenTransfer(false);
              setOpenTransferPreview(true);
            }}
            disabled={transferDisabled}
            className={
              transferDisabled
                ? "mt-8 bg-gray-400 flex justify-center items-center text-gray-200 text-[15px] font-medium h-[48px] w-full rounded-xl gap-2"
                : "mt-8 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl gap-2"
            }
          >
            Proceed
            <BsArrowRight className="text-[20px] text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Tranfer;
